import { render, staticRenderFns } from "./sureDeleteAll.vue?vue&type=template&id=5c5bfba2"
import script from "./sureDeleteAll.vue?vue&type=script&lang=js"
export * from "./sureDeleteAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports